var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoFaded = function SvgLogoFaded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460.81 405.08"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__a",
    x1: 83.28,
    y1: 130.35,
    x2: 240.78,
    y2: 130.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__b",
    x1: 124.7,
    y1: 148.45,
    x2: 260.84,
    y2: 148.45,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__c",
    x1: 167.72,
    y1: 167.44,
    x2: 283.38,
    y2: 167.44,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__d",
    x1: 211.55,
    y1: 186.25,
    x2: 303.86,
    y2: 186.25,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__e",
    x1: 0,
    y1: 396.31,
    x2: 292.9,
    y2: 396.31,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__f",
    x1: 21.33,
    y1: 360.63,
    x2: 272.19,
    y2: 360.63,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__g",
    x1: 42.94,
    y1: 322.75,
    x2: 250.68,
    y2: 322.75,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__h",
    x1: 65.28,
    y1: 285.49,
    x2: 228.77,
    y2: 285.49,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__i",
    x1: 306.24,
    y1: 275.62,
    x2: 460.81,
    y2: 275.62,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__j",
    x1: 285.53,
    y1: 293.19,
    x2: 419.43,
    y2: 293.19,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__k",
    x1: 264.02,
    y1: 312.09,
    x2: 375.28,
    y2: 312.09,
    xlinkHref: "#logo-faded_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-faded_svg__l",
    x1: 242.11,
    y1: 330.53,
    x2: 332.44,
    y2: 330.53,
    xlinkHref: "#logo-faded_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 260.7a8.61 8.61 0 0 1-7.45-12.91L224.71 4.31a8.61 8.61 0 0 1 14.92 8.6L99.35 256.39a8.62 8.62 0 0 1-7.47 4.31Z",
    style: {
      fill: "url(#logo-faded_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3 260.7a8.61 8.61 0 0 1-7.46-12.9L244.76 40.53a8.61 8.61 0 0 1 14.93 8.57L140.78 256.38a8.61 8.61 0 0 1-7.48 4.32Z",
    style: {
      fill: "url(#logo-faded_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32 260.7a8.51 8.51 0 0 1-4.32-1.17 8.61 8.61 0 0 1-3.11-11.77l98.43-169.3a8.61 8.61 0 1 1 14.89 8.65l-98.44 169.31a8.6 8.6 0 0 1-7.45 4.28Z",
    style: {
      fill: "url(#logo-faded_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.15 260.7a8.6 8.6 0 0 1-7.47-12.87l75.09-131.68a8.61 8.61 0 0 1 15 8.53l-75.13 131.67a8.61 8.61 0 0 1-7.49 4.35Z",
    style: {
      fill: "url(#logo-faded_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61 405.08a8.61 8.61 0 0 1 0-17.22l275.69-.33a8.61 8.61 0 0 1 0 17.22l-275.69.33Z",
    style: {
      fill: "url(#logo-faded_svg__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93 369.6a8.61 8.61 0 0 1 0-17.22l233.65-.72a8.61 8.61 0 0 1 0 17.22L30 369.6Z",
    style: {
      fill: "url(#logo-faded_svg__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.07 331.62-190.55-.52a8.61 8.61 0 0 1 0-17.22l190.53.52a8.61 8.61 0 0 1 0 17.22Z",
    style: {
      fill: "url(#logo-faded_svg__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89 294.54a8.61 8.61 0 0 1 0-17.22l146.27-.87a8.61 8.61 0 0 1 .05 17.22l-146.27.87Z",
    style: {
      fill: "url(#logo-faded_svg__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.21 404.91a8.61 8.61 0 0 1-7.49-4.35L307.37 159.2a8.61 8.61 0 0 1 15-8.52L459.69 392a8.61 8.61 0 0 1-3.23 11.74 8.49 8.49 0 0 1-4.25 1.17Z",
    style: {
      fill: "url(#logo-faded_svg__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.82 404.18a8.59 8.59 0 0 1-7.48-4.34L286.66 195.08a8.61 8.61 0 0 1 15-8.53L418.3 391.31a8.6 8.6 0 0 1-7.48 12.87Z",
    style: {
      fill: "url(#logo-faded_svg__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.68 404.72a8.58 8.58 0 0 1-7.52-4.4l-94-168a8.61 8.61 0 1 1 15-8.41l94 168a8.6 8.6 0 0 1-7.5 12.81Z",
    style: {
      fill: "url(#logo-faded_svg__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84 403.65a8.61 8.61 0 0 1-7.5-4.37l-73.11-129a8.61 8.61 0 1 1 15-8.49l73.11 129a8.6 8.6 0 0 1-3.24 11.73 8.48 8.48 0 0 1-4.26 1.13Z",
    style: {
      fill: "url(#logo-faded_svg__l)"
    }
  }));
};

export default SvgLogoFaded;